
export default function (Component) {
  Component.options.__source = "src/components/EchartTools/index.vue"
}
